<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of MBP Departments</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New MBP Department"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <mbpDepartmentsTable
          :key="mbpDepartmentsKey"
          :mbpDepartments="mbpDepartments"
          :loading="loading"
          @edit-MBPDepartment="editMBPDepartments"
          @delete-MBPDepartment="deleteMBPDepartment"
        />

        <mbpDepartmentsForm
          :mbpDepartmentToEdit="mbpDepartment"
          :key="mbpDepartmentsFormKey"
          :mbpDepartmentForm="mbpDepartmentsForm"
          :sendingRequest="sendingRequest"
          :disabledArr="disabledArr"
          @close="mbpDepartment = {}, mbpDepartmentsForm = false"
          @save="saveMBPDepartment"
        />

      </div>
    </div>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import mbpDepartmentsTable from './MBPDepartmentsTable'
import mbpDepartmentsForm from './MBPDepartmentsForm'

export default {
  components: {
    mbpDepartmentsTable,
    mbpDepartmentsForm
  },
  data: () => ({
    customerService: new CustomerService(),
    filters: '',
    mbpDepartmentsKey1: 0,
    mbpDepartments: [],
    mbpDepartmentsForm: false,
    mbpDepartmentsFormKey1: 0,
    disabledArr: [],
    mbpDepartment: {},
    requesting: false,
    sendingRequest: false
  }),
  computed: {
    mbpDepartmentsKey: {
      set(val) {
        this.mbpDepartmentsKey1++
      },
      get() {
        return 'mbpDepartmentsTable' + this.mbpDepartmentsKey1.toString()
      }
    },
    mbpDepartmentsFormKey: {
      set(val) {
        this.mbpDepartmentsFormKey1++
      },
      get() {
        return 'mbpDepartmentsForm' + this.mbpDepartmentsFormKey1.toString()
      }
    },
    loading() {
      if (this.mbpDepartments && this.mbpDepartments[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllMBPDepartmentsByHard()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    filters(val) {
      this.mbpDepartmentsKey++
    },
    mbpDepartmentsForm(val) {
      this.mbpDepartmentsFormKey++
    },
    mbpDepartments(val) {
      if (val && Array.isArray(val)) {
        this.mbpDepartmentsKey++
      }
    }
  },
  methods: {
    deleteMBPDepartment(mbpDepartment) {
      if (mbpDepartment && mbpDepartment.id) {
        this.customerService
          .deleteMBPDepartment(mbpDepartment.id)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "MBP Department deleted",
              detail: "MBP Department updated deleted.",
              life: 5000,
            });
          
            this.mbpDepartmentsForm = false
            this.getAllMBPDepartmentsByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while deleting MBP Department",
              life: 5000,
            })
          })
      }
    },
    editMBPDepartments(mbpDepartment) {
      
      this.mbpDepartment = mbpDepartment
      this.mbpDepartmentsForm = true
    },
    saveMBPDepartment(mbpDepartment) {
      

      delete mbpDepartment.createdBy
      delete mbpDepartment.updatedBy

      this.sendingRequest = true

      if (mbpDepartment.id) {

        this.customerService
          .editMBPDepartment(mbpDepartment)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "MBP Department updated",
              detail: "MBP Department updated successfully.",
              life: 5000,
            });
          
            this.sendingRequest = false
            this.mbpDepartmentsForm = false
            this.getAllMBPDepartmentsByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating MBP Department",
              life: 5000,
            })
          })
      } else {
        this.customerService
          .saveMBPDepartment(mbpDepartment)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "MBP Department saved",
              detail: "MBP Department saved successfully.",
              life: 5000,
            })
          
            this.sendingRequest = false
            this.mbpDepartmentsForm = false
            this.getAllMBPDepartmentsByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving MBP Department",
              life: 5000,
            })
          })
      }
    },
    getAllMBPDepartmentsByHard() {
      this.requesting = true
      this.customerService
        .getAllMBPDepartmentsByHard()
        .then(data => {
          this.requesting = false
          this.mbpDepartments = data
        })
        .catch(err => {
          this.requesting = false
          
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "/v1/mbpdepts"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.mbpDepartment = {}
      this.mbpDepartmentsForm = true
    }
  }
}
</script>

<style>

</style>